module.exports = __webpack_public_path__ + "img/k12_feature1.36e8cdc2.png";